export default "https://cdn-static.gokick.com/assets/31bbee86f9627d9d8b331552e0c9ca66f3d2b554/images/citrus-zen.2d0942f5031f42be498b3d61071e3237.png";